import {
    INBOX_PAGE_CHALLENGE_REQ_ACTION,
    INBOX_PAGE_JOIN_GROUP_CONSENT_DIALOG_ACTION,
    INBOX_PAGE_CONNECTION_REQ_ACTION,
    INBOX_PAGE_FETCH_REQUESTS,
    INBOX_PAGE_FETCH_REQUESTS_DONE,
    INBOX_PAGE_GROUP_REQ_ACTION,
    INBOX_PAGE_RESET,
    INBOX_PAGE_SET_JOIN_GROUP_CONSENT_DIALOG_OPEN,
    INBOX_PAGE_SET_MUTUAL_CONNECTION_DIALOG_OPEN,
    INBOX_PAGE_SET_CHALLENGE_DIALOG_OPEN,
    INBOX_PAGE_SET_REQ_STATUS,
    INBOX_PAGE_SET_DATA_PRIVACY_DIALOG_OPEN,
    INBOX_PAGE_DATA_PRIVACY_DIALOG_ACTION,
    INBOX_PAGE_SET_GROUP_ERROR_DIALOG_OPEN,
    INBOX_PAGE_INIT,
    INBOX_PAGE_CHALLENGE_DIALOG_ACTION,
    INBOX_PAGE_DEVICE_REQ_ACTION,
    INBOX_PAGE_DELETE_GROUP_REQ_DIALOG_ACTION,
    INBOX_PAGE_SET_DELETE_GROUP_REQ_DIALOG_OPEN
} from './ActionTypes';

export const inboxPageInit = ({ viewerSocialProfile, viewerUserPreferences }) => ({
    type: INBOX_PAGE_INIT,
    viewerSocialProfile,
    viewerUserPreferences
});

export const inboxPageReset = () => ({
    type: INBOX_PAGE_RESET
});

/**
 * fetch requests
 * @returns
 */
export const inboxPageFetchRequests = ({ cursor = null, limit = 50 }) => ({
    type: INBOX_PAGE_FETCH_REQUESTS,
    cursor,
    limit
});

/**
 * fetch requests done
 * @param {{
 *  error?: boolean;
 *  requests?: unknown[];
 *  nextCursor?: string;
 *  profileInfos?: { [profileId: string]: SimplePublicSocialProfileV2DTO }
 * }} payload
 * @returns
 */
export const inboxPageFetchRequestsDone = ({ error, requests, nextCursor, profileInfos }) => ({
    type: INBOX_PAGE_FETCH_REQUESTS_DONE,
    error,
    requests,
    nextCursor,
    profileInfos
});

export const inboxPageSetChallengeDialogOpen = ({ open, dialogType = null, uniqueKey = null, request = null }) => ({
    type: INBOX_PAGE_SET_CHALLENGE_DIALOG_OPEN,
    open,
    dialogType,
    uniqueKey,
    request
});

export const inboxPageChallengeDialogAction = ({ doNotShowAgain = false, ok }) => ({
    type: INBOX_PAGE_CHALLENGE_DIALOG_ACTION,
    doNotShowAgain,
    ok
});

export const inboxPageConnectionRequestAction = ({ uniqueKey, request, accept }) => ({
    type: INBOX_PAGE_CONNECTION_REQ_ACTION,
    uniqueKey,
    request,
    accept
});

export const inboxPageChallengeRequestAction = ({ uniqueKey, request, accept }) => ({
    type: INBOX_PAGE_CHALLENGE_REQ_ACTION,
    uniqueKey,
    request,
    accept
});

export const inboxPageGroupRequestAction = ({ uniqueKey, request, accept }) => ({
    type: INBOX_PAGE_GROUP_REQ_ACTION,
    uniqueKey,
    request,
    accept
});

/**
 *
 * @param {{
 *  uniqueKey: string;
 *  request: object;
 *  newStatus: 'DECLINED' | 'INVITED'
 * }} payload
 * @returns
 */
export const inboxPageDeviceRequestAction = ({ uniqueKey, request, newStatus }) => ({
    type: INBOX_PAGE_DEVICE_REQ_ACTION,
    uniqueKey,
    request,
    newStatus
});

export const inboxPageSetRequestStatus = ({ uniqueKey, status }) => ({
    type: INBOX_PAGE_SET_REQ_STATUS,
    uniqueKey,
    status
});

export const inboxPageSetMutualConnectionDialogOpen = ({ open, displayName, mutualConnectionsCount }) => ({
    type: INBOX_PAGE_SET_MUTUAL_CONNECTION_DIALOG_OPEN,
    open,
    displayName,
    mutualConnectionsCount
});

export const inboxPageSetJoinGroupConsentDialogOpen = ({ open, uniqueKey = null, request = null }) => ({
    type: INBOX_PAGE_SET_JOIN_GROUP_CONSENT_DIALOG_OPEN,
    open,
    uniqueKey,
    request
});

export const inboxPageJoinGroupConsentDialogAction = (confirm) => ({
    type: INBOX_PAGE_JOIN_GROUP_CONSENT_DIALOG_ACTION,
    confirm
});

export const inboxPageSetDataPrivacyDialogOpen = ({ open, uniqueKey = null, request = null }) => ({
    type: INBOX_PAGE_SET_DATA_PRIVACY_DIALOG_OPEN,
    open,
    uniqueKey,
    request
});

export const inboxPageDataPrivacyDialogAction = (actionType) => ({
    type: INBOX_PAGE_DATA_PRIVACY_DIALOG_ACTION,
    actionType
});

export const inboxPageSetGroupErrorDialogOpen = ({ open, errorType = null }) => ({
    type: INBOX_PAGE_SET_GROUP_ERROR_DIALOG_OPEN,
    open,
    errorType
});

export const inboxPageSetDeleteGroupRequestDialogOpen = ({ open, uniqueKey = null, request = null }) => ({
    type: INBOX_PAGE_SET_DELETE_GROUP_REQ_DIALOG_OPEN,
    open,
    uniqueKey,
    request
});

export const inboxPageDeleteGroupRequestDialogAction = (confirm) => ({
    type: INBOX_PAGE_DELETE_GROUP_REQ_DIALOG_ACTION,
    confirm
});
